import _ from "lodash";

export function convertKeysToCamelCaseDeep(input) {
  if (_.isArray(input)) {
    return input.map(convertKeysToCamelCaseDeep);
  }

  if (_.isPlainObject(input)) {
    return _.transform(
      input,
      (result, value, key) => {
        const camelKey = _.camelCase(key);
        result[camelKey] = convertKeysToCamelCaseDeep(value);
      },
      {}
    );
  }

  return input;
}
